import React, { useEffect, useRef, useState } from 'react';
import { FaVolumeMute, FaVolumeUp } from 'react-icons/fa';
import { MdLanguage } from 'react-icons/md';
import music from '../assets/final.mp3';

const Navbar = ({ setIsArabic, isArabic }) => {
  const [isMute, setIsMute] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    // Play the music on component mount
    if (audioRef.current) {
      audioRef.current.play();
      audioRef.current.loop = true; // Loop the music
    }
  }, []);

  useEffect(() => {
    // Mute or unmute the music based on `isMute` state
    if (audioRef.current) {
      audioRef.current.muted = isMute;
    }
  }, [isMute]);

  const toggleMute = () => {
    setIsMute((prev) => !prev);
  };

  return (
    <div className={`w-full flex justify-between items-center relative z-20 ${isArabic && 'flex-row-reverse'}`}>
      <div className="z-20 cursor-pointer flex items-center gap-2" onClick={() => setIsArabic((prev) => !prev)}>
        
        {isArabic ? 'English' : 'عربي'}
      </div>

      <div className="z-20 cursor-pointer flex items-center gap-2" onClick={toggleMute}>
        {isMute ? <FaVolumeMute size={24} /> : <FaVolumeUp size={24} />}
      </div>

      {/* Audio element for music playback */}
      <audio ref={audioRef} src={music} />
    </div>
  );
};

export default Navbar;
